
 <div class="bodyDiv bg-white text-black">
  <!-- Header & Hero -->
  <header class="relative pb-8 overflow-hidden" style="background-image: url('assets/headerbg.png'); background-size: cover; background-position: center;">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <nav class="flex items-center justify-between py-3 text-white text-sm font-semibold">
     <div class="flex items-center space-x-2">
      <img alt="Atlas Track logo, white plus sign with track icon" class="w-40 h-16" height="24" src="assets/horizontal-white-logo.png" width="24"/>
      
     </div>
     <ul class="hidden md:flex space-x-8">
      <li>
       <a class="hover:underline" href="#">
        Products
       </a>
      </li>
      <li>
       <a class="hover:underline" href="#">
        Industries
       </a>
      </li>
      <li>
       <a class="hover:underline" href="#">
        Discover
       </a>
      </li>
      <li>
       <a class="hover:underline" href="#">
        Company
       </a>
      </li>
      <li>
       <a class="hover:underline" href="#">
        Support
       </a>
      </li>
      <li>
       <a class="hover:underline" href="#">
        Language
       </a>
      </li>
     </ul>
     <div class="hidden md:flex space-x-4 items-center">
      <button aria-label="Search" class="hover:text-gray-300">
       <i class="fas fa-search">
       </i>
      </button>
      <button aria-label="User account" class="hover:text-gray-300" (click)="onUserClick()">
       <i class="fas fa-user">
       </i>
      </button>
      <button aria-label="Shopping cart" class="hover:text-gray-300">
       <i class="fas fa-shopping-cart">
       </i>
      </button>
     </div>
     <button aria-label="Open menu" class="md:hidden text-white focus:outline-none focus:ring-2 focus:ring-white">
      <i class="fas fa-bars">
      </i>
     </button>
    </nav>
    <div class="text-center max-w-3xl mx-auto pt-10 pb-20 relative z-10">
     <h1 class="text-white text-3xl sm:text-5xl font-semibold leading-snug">
      Grow Fast and Work
      <br>
      <span class="mt-4">Smart</span>
      
     </h1>
     <p class="text-white mt-4 text-base sm:text-2xl font-normal">
      Start Simple With Start Suits
     </p>
     <div class="mt-6 flex justify-center space-x-4">
      <button class=" bg-transparent text-white border border-white  font-semibold rounded-full px-16 py-2 text-sm sm:text-base hover:bg-gray-100 transition">
       Get Now
      </button>
      <button class="bg-white text-[#9B3AFF]    font-semibold rounded-full px-16 py-2 text-sm sm:text-base hover:bg-[#7a2ed9] transition">
        See demo
      </button>
     </div>
    </div>
    <!-- Hero image container -->
    <div class="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
     <div aria-label="Dashboard interface with purple gradient background" class="rounded-xl overflow-hidden border border-white border-opacity-30 shadow-lg bg-white h-[350px] sm:h-[350px]">
        <div class="maincontainer font-sans gap-8">
         
           
            <div class="flex flex-col md:flex-row h-screen">
                <!-- Mobile Header with Menu Toggle -->
                <div class="block md:hidden bg-white p-4 shadow-sm">
                    <div class="flex items-center justify-between">
                        <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
                        <button class="text-gray-600" >
                            <i class="fas fa-bars text-xl"></i>
                        </button>
                    </div>
                </div>
        
                <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
                <div class="w-full md:w-60 bg-white p-4 text-xs  sidebar-menu" >
                   <div class="flex items-center justify-center h-12 md:h-16 mb-6">
                       <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
                   </div>
                   <div class="mt-4 md:mt-10">
                       <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" >
                           <i class="fas fa-th-large mr-3"></i>
                           <span>Home</span>
                       </a>
                       
                       <!-- Reports Dropdown Menu -->
                       <div class="relative ">
                           <!-- Reports Menu Header -->
                           <a class=" text-xs flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" >
                               <i class="fas fa-file-alt mr-3"></i>
                               <span>Download Reports</span>
                               <i class="fas fa-caret-down ml-auto"></i>
                           </a>
                           
                           <!-- Dropdown Items -->
                           
                       </div>
                       
                       <a class="flex  items-center py-2 mt-1 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" >
                           <i class="fas fa-database mr-3"></i>
                           <span>Biological Indicator Device</span>
                       </a>
                   </div>
               </div>
                
                <!-- Main Content -->
                <div class="flex-1 flex flex-col">
                    <!-- Header -->
                    <header class="flex items-center justify-between h-12 md:h-12 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
                        <div class="flex items-center">
                            <h1 class="text-gray-600 text-sm font-medium">
                               Dashboard / Biological Indicator Report
                            </h1>
                        </div>
                        <div class="flex items-center">
                            <div class="relative">
                            </div>
                            <div class="flex items-center gap-2 md:gap-4">
                                <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
                            
                              
                            </div>
                        </div>
                    </header>
                    
                   
                   <!-- Main Section -->
                   <main class="flex-1 p-3 md:p-6 overflow-auto">
                       <div class="bg-gradient-to-l from-[rgba(173,0,255,0.75)] to-[rgba(173,0,255,1)] h-28 md:h-28  rounded-lg mb-4 md:mb-6">
                
                       </div>
                       
                       <div class=" text-xs bg-white p-3 md:p-6 rounded-lg shadow-xl">
                           <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 space-y-3 md:space-y-0">
                               <div class="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                               
                                   <input class="w-full sm:w-auto px-4 py-1 border border-gray-300 rounded-lg  sm:mb-0" type="date"/>
                                
                                   <input class="w-full sm:w-auto px-4 py-1 border border-gray-300 rounded-lg" type="date" />
                               </div>
                               <div class="flex space-x-2 md:space-x-4">
                                   <!-- <button class="flex-1 md:flex-none px-3 md:px-4 py-1 bg-red-100 text-red-600 rounded-lg text-xs md:text-base" >
                                       PDF
                                       <i class="fas fa-download text-red-500 ml-2"></i>
                                   </button>
                                   <button class="flex-1 md:flex-none px-3 md:px-4 py-1 bg-green-100 text-green-600 rounded-lg text-xs md:text-base" >
                                       Excel
                                       <i class="fas fa-download text-green-500 ml-2"></i>
                                   </button> -->
                               </div>
                           </div>
                           
                           <!-- Responsive Table - Scrollable horizontally on small screens -->
                           <div class="overflow-x-auto -mx-3 md:mx-0">
                               <table class="min-w-full text-xs text-left">
                                   <thead class="bg-blue-100 text-xs columnheading rounded-lg">
                                       <tr>
                                           <th class="py-1 px-1 border-b border-gray-200">ID</th>
                                           <th class="py-1 px-2 border-b border-gray-200">Start Time</th>
                                           <th class="py-1 px-2 border-b border-gray-200">End Time</th> 
                                           <th class="py-2 px-1 border-b border-gray-200">Well</th>
                                           <th class="py-2 px-1 border-b border-gray-200">Serial</th>
                                           <th class="py-1 px-1 border-b border-gray-200">Result</th>
                                           <th class="py-1 px-4 border-b border-gray-200">BI Type</th>
                                
                                          
                                           <th class="py-1 px-3 border-b border-gray-200">Control</th>
                                           <th class="py-1 px-3 border-b border-gray-200">Implant</th>
                                       </tr>
                                   </thead>
                                   <tbody class="bg-white">
                                      <tr>
                                        <th class="py-1 px-1 border-b border-gray-200">ID</th>
                                           <td class="py-1 px-2 border-b border-gray-200">12-Feb-2025</td>
                                           <td class="py-1 px-2 border-b border-gray-200">12-Feb-2025</td> 
                                           <td class="py-2 px-1 border-b border-gray-200">12</td>
                                           <td class="py-2 px-1 border-b border-gray-200">SN-1234</td>
                                           <td class="py-1 px-1 border-b text-green-600 border-gray-200">Positive</td>
                                           <td class="py-1 px-4 border-b border-gray-200">BT-12345</td>
                                
                                          
                                           <td class="py-1 px-3 border-b  border-gray-200"><p class="bg-blue-100 text-blue-500 text-center rounded-full p-1">Control</p></td>
                                           <td class="py-1 px-3 border-b  border-gray-200"><p class="bg-purple-100 text-purple-500 text-center rounded-full p-1">Implant</p></td>

                                      </tr>
                                   </tbody>
                               </table>
                           </div>
                           
                           <!-- Pagination -->
                           
                       </div>
                   </main>
               </div>
           </div>
           
          
       </div>
     </div>
    </div>

   </div>
  </header>
  <!-- Learn Valuable Skill Section -->
  <section class="max-w-7xl text-center  mx-auto px-4 sm:px-6 lg:px-8 py-16">
   <h2 class="text-4xl font-semibold  mb-10  pb-1 ">
     Learn Valuable Skill
   </h2>
 
   <div class="grid grid-cols-1 sm:grid-cols-3 pl-16 pr-160 gap-0 text-center">
    <div>
     <div class="mx-auto w-24 h-24  flex items-center justify-center text-white text-xl mb-2">
     <img src="assets/quicklookicon.png" alt="">
     </div>
     <h3 class="font-semibold text-3xl mb-2">
      Quick Look
     </h3>
     <p class="text-lg text-gray-400 max-w-[280px] mx-auto">
      Learn how to grow your business fast, improve productivity with your
          customers.
     </p>
    </div>
    <div>
        <div class="mx-auto w-24 h-24 flex items-center justify-center text-white text-xl mb-2">
        <img src="assets/atlascrmicon.png" alt="">
        </div>
        <h3 class="font-semibold text-3xl mb-2">
            Atlas CRM
        </h3>
        <p class="text-lg text-gray-400 max-w-[280px] mx-auto">
            Learn how to use customer relationship management (CRM) software to grow your business.
        </p>
       </div>
       <div>
        <div class="mx-auto w-24 h-24  flex items-center justify-center text-white text-xl mb-2">
        <img src="assets/salesicon.png" alt="">
        </div>
        <h3 class="font-semibold text-3xl mb-2">
            Sales Cloud Basics
        </h3>
        <p class="text-lg text-gray-400 max-w-[280px] mx-auto">
            Grow your business, boost productivity, and make smart decisions with Sales Cloud.
        </p>
       </div>
   </div>
  </section>
  <!-- Learn what we products can do for you -->
  <section class="max-w-7xl relative bg-[#F9F9F9] mx-auto px-4 sm:px-6 lg:px-8 pb-16 ">
   <h2 class="text-4xl font-semibold max-w-max p-10 pb-1 mb-16">
    Learn what we products
    <br/>
    can do for you.
   </h2>
   <div class="grid grid-cols-1 sm:grid-cols-3 gap-6">
    <!-- Card 1 -->
    <article class="bg-[#F3E6FF] rounded-lg p-5 shadow-sm flex flex-col justify-between">
     <img alt="Illustration of a woman standing in front of a small business store with purple and pink tones" class="rounded-md mb-4" height="180" src="https://storage.googleapis.com/a1aa/image/2b2a5889-a645-4411-003f-2f1b6f037387.jpg" width="300"/>
     <h3 class="font-semibold text-sm mb-1">
      Small Business
     </h3>
     <p class="text-xs mb-3">
      Sell smarter and provide support faster in a single app.
     </p>
     <a class="text-[#7A2ED9] text-xs font-semibold hover:underline inline-flex items-center" href="#">
      Read More
      <i class="fas fa-chevron-right ml-1">
      </i>
     </a>
    </article>
    <!-- Card 2 -->
    <article class="bg-[#FFF3E6] rounded-lg p-5 shadow-sm flex flex-col justify-between">
     <img alt="Illustration of two men with money and growth chart, yellow and orange tones" class="rounded-md mb-4" height="180" src="https://storage.googleapis.com/a1aa/image/9400655c-7a7f-413d-b040-cc8994dbc831.jpg" width="300"/>
     <h3 class="font-semibold text-sm mb-1">
      Sales Cloud
     </h3>
     <p class="text-xs mb-3">
      Sell smarter and provide support faster in a single app.
     </p>
     <a class="text-[#7A2ED9] text-xs font-semibold hover:underline inline-flex items-center" href="#">
      Read More
      <i class="fas fa-chevron-right ml-1">
      </i>
     </a>
    </article>
    <!-- Card 3 -->
    <article class="bg-[#E6FFFB] rounded-lg p-5 shadow-sm flex flex-col justify-between">
     <img alt="Illustration of a man working on marketing with charts and people, teal and green tones" class="rounded-md mb-4" height="180" src="https://storage.googleapis.com/a1aa/image/b03248b1-3737-4230-af94-4566e75facb6.jpg" width="300"/>
     <h3 class="font-semibold text-sm mb-1">
      Marketing Cloud
     </h3>
     <p class="text-xs mb-3">
      Sell smarter and provide support faster in a single app.
     </p>
     <a class="text-[#7A2ED9] text-xs font-semibold hover:underline inline-flex items-center" href="#">
      Read More
      <i class="fas fa-chevron-right ml-1">
      </i>
     </a>
    </article>
    <!-- Card 4 -->
    <article class="bg-[#E6F0FF] rounded-lg p-5 shadow-sm flex flex-col justify-between">
     <img alt="Illustration of a man working on computer with cloud icons, blue tones" class="rounded-md mb-4" height="180" src="https://storage.googleapis.com/a1aa/image/d16bf13b-7034-43d6-41af-7b58e3eafbd2.jpg" width="300"/>
     <h3 class="font-semibold text-sm mb-1">
      Service Cloud
     </h3>
     <p class="text-xs mb-3">
      Sell smarter and provide support faster in a single app.
     </p>
     <a class="text-[#7A2ED9] text-xs font-semibold hover:underline inline-flex items-center" href="#">
      Read More
      <i class="fas fa-chevron-right ml-1">
      </i>
     </a>
    </article>
    <!-- Card 5 -->
    <article class="bg-[#D9FFE6] rounded-lg p-5 shadow-sm flex flex-col justify-between">
     <img alt="Illustration of Albert Einstein teaching with chalkboard, green tones" class="rounded-md mb-4" height="180" src="https://storage.googleapis.com/a1aa/image/3c7ee4ab-ee8f-49e6-4daa-f5b564f3984a.jpg" width="300"/>
     <h3 class="font-semibold text-sm mb-1">
      Einstein AI
     </h3>
     <p class="text-xs mb-3">
      Sell smarter and provide support faster in a single app.
     </p>
     <a class="text-[#7A2ED9] text-xs font-semibold hover:underline inline-flex items-center" href="#">
      Read More
      <i class="fas fa-chevron-right ml-1">
      </i>
     </a>
    </article>
    <!-- Card 6 -->
    <article class="bg-[#FFE6E6] rounded-lg p-5 shadow-sm flex flex-col justify-between">
     <img alt="Illustration of two people shopping and working on commerce, red tones" class="rounded-md mb-4" height="180" src="https://storage.googleapis.com/a1aa/image/7e4fa0a5-d7e9-4052-a5bf-60d079475769.jpg" width="300"/>
     <h3 class="font-semibold text-sm mb-1">
      Commerce Cloud
     </h3>
     <p class="text-xs mb-3">
      Sell smarter and provide support faster in a single app.
     </p>
     <a class="text-[#7A2ED9] text-xs font-semibold hover:underline inline-flex items-center" href="#">
      Read More
      <i class="fas fa-chevron-right ml-1">
      </i>
     </a>
    </article>
   </div>
  </section>
  <!-- Our Success Stories -->
  <section class="relative  py-20 overflow-visible">
   <div class="max-w-3xl mx-auto text-center px-4 sm:px-6 lg:px-8">
    <h2 class="text-4xl font-semibold max-w-max mx-auto pb-1 mb-3">
     Our Success Stories
    </h2>
    <p class="text-xs max-w-md mx-auto mb-12">
     Cras convallis lacus orci, tristique tincidunt magna consequat in.
    </p>
    <div aria-label="Decorative circles" class="grid grid-cols-3 gap-10 max-w-md-xl lg:ml-8 ">
     <div class="lg:w-36 lg:h-36 w-28 h-28 lg:mt-36 rounded-full border-2 border-[#9B3AFF] border-dashed">
     </div>
     <div class="lg:w-36 lg:h-36 w-28 h-28 rounded-full border-2 border-[#9B3AFF] border-dashed">
     </div>
     <div class="lg:w-36 lg:h-36 w-28 h-28 lg:mt-36  rounded-full border-2 border-[#9B3AFF] border-dashed">
     </div>
     </div>
     <button class="bg-[#BA29FF] -mt-10 text-white text-xs mb-10 rounded-full py-1.5 px-6  font-semibold  transition">
        SHOW ALL SUCCESS STORIES
       </button>
     <div aria-label="Decorative circles" class="grid grid-cols-3 gap-10 max-w-md-xl lg:ml-10 mb-10">
     <div class="lg:w-36 lg:h-36 w-28 h-28 lg:mt-20 rounded-full border-2 border-[#9B3AFF] border-dashed">
     </div>
     <div class="lg:w-36 lg:h-36 w-28 h-28 mt- rounded-full border-2 border-[#9B3AFF] border-dashed">
     </div>
     <div class="lg:w-36 lg:h-36 w-28 h-28 lg:mt-20 rounded-full border-2 border-[#9B3AFF] border-dashed">
     </div>
  
    </div>
 
   
  
   
   </div>
   <!-- Decorative lines with dots -->
   <svg aria-hidden="true" class="absolute top-0 left-0 w-40 h-96 opacity-30" fill="none" viewbox="0 0 100 240" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C20 40 0 80 10 120C20 160 0 200 10 240" stroke="#9B3AFF" stroke-dasharray="4 4" stroke-width="0.5">
    </path>
    <circle cx="10" cy="0" fill="#9B3AFF" r="1.5">
    </circle>
    <circle cx="10" cy="120" fill="#9B3AFF" r="1.5">
    </circle>
    <circle cx="10" cy="240" fill="#9B3AFF" r="1.5">
    </circle>
   </svg>
   <svg aria-hidden="true" class="absolute bottom-0 right-0 w-40 h-96 opacity-30" fill="none" viewbox="0 0 100 240" xmlns="http://www.w3.org/2000/svg">
    <path d="M90 240C80 200 100 160 90 120C80 80 100 40 90 0" stroke="#9B3AFF" stroke-dasharray="4 4" stroke-width="0.5">
    </path>
    <circle cx="90" cy="240" fill="#9B3AFF" r="1.5">
    </circle>
    <circle cx="90" cy="120" fill="#9B3AFF" r="1.5">
    </circle>
    <circle cx="90" cy="0" fill="#9B3AFF" r="1.5">
    </circle>
   </svg>
  </section>
  <!-- Elevate Your Potential Section -->
  <section class="max-w-7xl  mx-auto px-4 sm:px-6 lg:px-8 space-y-10 pb-16">
   <div aria-label="Elevate Your Potential with AI and ML Excellence" class="row items-center bg-[#F2F2F2] rounded-xl p-6 md:p-10 gap-6">
    <div class=" flex-0 max-w-xl">
     <h3 class="text-4xl leading-tight mb-4">
      Elevate Your Potential
      <br/>
      With AI And ML 
      <br>
      Excellence.
     </h3>
     <p class="text-small text-gray-400 mb-6">
        Transforming Ideas into Innovations.
     </p>
     <button class="bg-[#BA29FF] text-white text-xs rounded-full px-16 py-3 font-semibold hover:bg-[#7a2ed9] transition">
      Get AI Suite For Free
     </button>
    </div>
    <div class="flex-1 max-w-xl relative">
     <img alt="Two mobile app screens showing AI and ML features with blue and white interface" class="rounded-xl shadow-lg w-280 h-280"  src="https://storage.googleapis.com/a1aa/image/72fe39b1-71f0-45bf-494e-dbfe49535261.jpg" width="280"/>
    </div>
   </div>
   <div aria-label="Software For Startups/Growth Companies On A Fixed Quote" class="flex flex-col md:flex-row items-center bg-[#E6F4FF] rounded-xl p-6 md:p-10 gap-6">
    <div class="flex-1 max-w-md relative">
     <img alt="Blue themed software app screens with charts and mobile devices" class="rounded-xl shadow-lg" height="180" src="https://storage.googleapis.com/a1aa/image/690c42d9-4da4-4a81-5b88-f8aed8e2c769.jpg" width="280"/>
    </div>
    <div class="flex-1 max-w-md">
     <h3 class="text-4xl leading-tight mb-4">
      Software For Startups/
      <br/>
      Growth Companies On A Fixed Quote
     </h3>
     <p class="text-xs mb-6">
      We work with more 25 different startups successfully.
     </p>
     <button class="bg-[#BA29FF] text-white text-xs rounded-full px-16 py-3 font-semibold hover:bg-[#7a2ed9] transition">
      Talk With Our Dev. Project
     </button>
    </div>
   </div>
  </section>
  <!-- What people said -->
  <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
   <h2 class="text-4xl  max-w-max mx-auto border-b-4 border-[#9B3AFF] pb-1 mb-10">
    What people said
   </h2>
   <div class="relative max-w-md mx-auto gap-10">
    <button aria-label="Previous testimonial" class="absolute top-1/2 -left-8  mr-4 transform -translate-y-1/2 bg-[#9B3AFF] text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-[#7a2ed9] transition">
     <i class="fas fa-chevron-left">
     </i>
    </button>
    <img alt="Two women sitting and talking in a park with trees and playground in background, purple overlay" class="rounded-lg" height="140" src="https://storage.googleapis.com/a1aa/image/224f0400-f929-41cd-05b0-8286d359de45.jpg" width="450"/>
    <button aria-label="Next testimonial" class="absolute top-1/2 -right-8 transform -translate-y-1/2 bg-[#9B3AFF] text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-[#7a2ed9] transition">
     <i class="fas fa-chevron-right">
     </i>
    </button>
    <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#9B3AFF] to-transparent text-white text-xs py-2 rounded-b-lg">
     Cras convallis lacus orci
    </div>
   </div>
  </section>
  <!-- Say hello to Us -->
  <section class="relative bg-[#F3E6FF] pt-20 pb-32 overflow-visible">
    
   <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="bg-white rounded-xl p-6 sm:p-10 shadow-md max-w-3xl mx-auto">
        <p class="text-4xl ">Say hello to Us</p>
    <form aria-label="Contact form" class="bg-white rounded-xl p-6 sm:p-10 max-w-3xl  grid grid-cols-1 sm:grid-cols-1 gap-4">
    <div class="">
        <div >
      <input class="w-full border border-gray-800 rounded-md px-3 py-2.5 text-xs focus:outline-none focus:ring-2 focus:ring-[#9B3AFF]" id="name" name="name" placeholder="Your name" type="text"/>
     </div>
     <div class="col-span-4 mt-4 sm:col-span-4">
      <input class="w-full border border-gray-800 rounded-md px-3 py-2.5 text-xs focus:outline-none focus:ring-2 focus:ring-[#9B3AFF]" id="email" name="email" placeholder="Your email" type="email"/>
     </div>
    </div>
     <div class="col-span-1 w-[250px]  sm:col-span-1">
    
      <textarea class="w-full border border-gray-800 rounded-md px-3 py-6 text-xs resize-none focus:outline-none focus:ring-2 focus:ring-[#9B3AFF]" id="message" name="message" placeholder="Message" rows="3"></textarea>
     </div>
     <div class="col-span-1 sm:col-span-3 flex items-center space-x-8 mt-2">
      <label class="flex lg:ml-32 items-center border-1 lg:px-4 lg:py-3  rounded-lg text-xs text-gray-600 cursor-pointer select-none" for="robot">
       <input class="w-4 h-4  text-[#9B3AFF] border-gray-300 rounded focus:ring-[#9B3AFF]" id="robot" name="robot" type="checkbox"/>
       <span class="ml-2">
        I'm not robot
       </span>
      </label>
      <div class="lg:ml-40 sm:ml-0"></div>
      <button class="ml-auto bg-[#BA29FF] text-white text-xs rounded-full px-16 py-2 font-semibold hover:bg-[#BA29FF] transition" type="submit">
       Send
      </button>
     </div>
    </form>
</div>
   </div>
   <!-- Purple wave shape bottom -->
   <svg class="absolute bottom-0 left-0 w-full h-48 text-[#B33AFF] opacity-30" fill="none" preserveaspectratio="none" viewbox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
    <path d="M0,224L48,197.3C96,171,192,117,288,117.3C384,117,480,171,576,197.3C672,224,768,224,864,197.3C960,171,1056,117,1152,117.3C1248,117,1344,171,1392,197.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="currentColor">
    </path>
   </svg>
  </section>
  <!-- Footer -->
  <footer class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
   <p>
    © 2023 Plus Track. All rights reserved.
   </p>
   <nav class="flex space-x-6 mt-3 sm:mt-0">
    <a class="hover:text-[#9B3AFF] font-semibold" href="#">
     About
    </a>
    <a class="hover:text-[#9B3AFF] font-semibold" href="#">
     Career
    </a>
    <a class="hover:text-[#9B3AFF] font-semibold" href="#">
     All Blog
    </a>
    <a class="hover:text-[#9B3AFF] font-semibold" href="#">
     Faq
    </a>
    <a class="hover:text-[#9B3AFF] font-semibold" href="#">
     Terms
    </a>
   </nav>
   <div class="flex space-x-6 mt-3 sm:mt-0 text-[#9B3AFF]">
    <a aria-label="Facebook" class="hover:text-[#7a2ed9]" href="#">
     <i class="fab fa-facebook-f">
     </i>
    </a>
    <a aria-label="Twitter" class="hover:text-[#7a2ed9]" href="#">
     <i class="fab fa-twitter">
     </i>
    </a>
    <a aria-label="Instagram" class="hover:text-[#7a2ed9]" href="#">
     <i class="fab fa-instagram">
     </i>
    </a>
   </div>
  </footer>


